import img_0 from "./img_0.png";
import img_1 from "./img_1.png";
import img_2 from "./img_2.png";
import img_3 from "./img_3.png";
import img_4 from "./img_4.png";

export default {
  v: "5.5.5",
  fr: 29.9700012207031,
  ip: 0,
  op: 180.00000733155,
  w: 808,
  h: 595,
  nm: "Bringing West Coast Technology to the Midwest 2",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 173,
      h: 172,
      u: "",
      p: img_0,
      e: 0
    },
    {
      id: "image_1",
      w: 204,
      h: 154,
      u: "",
      p: img_1,
      e: 0
    },
    {
      id: "image_2",
      w: 182,
      h: 182,
      u: "",
      p: img_2,
      e: 0
    },
    {
      id: "image_3",
      w: 233,
      h: 89,
      u: "",
      p: img_3,
      e: 0
    },
    {
      id: "image_4",
      w: 1083,
      h: 366,
      u: "",
      p: img_4,
      e: 0
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: "Left Hand",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [301.585, 84.577, 0], ix: 2 },
        a: { a: 0, k: [86.027, 85.827, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: "Right Hand",
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [577.243, 186.195, 0], ix: 2 },
        a: { a: 0, k: [101.519, 76.729, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: "CPU",
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [346.187, 111.675, 0],
              to: [36.5, 6.103, 0],
              ti: [-36.5, -6.103, 0]
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 60,
              s: [565.187, 148.293, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0]
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 90,
              s: [565.187, 148.293, 0],
              to: [-36.5, -6.103, 0],
              ti: [36.5, 6.103, 0]
            },
            { t: 150.000006109625, s: [346.187, 111.675, 0] }
          ],
          ix: 2
        },
        a: { a: 0, k: [90.735, 90.735, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: "Right Fingers",
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [606.503, 189.626, 0], ix: 2 },
        a: { a: 0, k: [116.495, 44.068, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "Waves of Grain",
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [437.455, 445.013, 0], ix: 2 },
        a: { a: 0, k: [541.482, 182.861, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
